import React, { useState, useEffect } from 'react';
import { getMenuItems, createMenuItem, updateMenuItem, deleteMenuItem } from '../../services/api';
import { useNavigate } from 'react-router-dom';

function ManageMenuItemsScreen() {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ ItemID: null, Name: '', Price: '', Destination: 'kitchen' });
  const navigate = useNavigate();
  const restaurantId = localStorage.getItem('restaurantId');

  useEffect(() => {
    if (!restaurantId) {
      setError('ID do restaurante não encontrado. Faça login novamente.');
      setLoading(false);
      return;
    }
    fetchMenuItems();
  }, [restaurantId]);

  const fetchMenuItems = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getMenuItems();
      setMenuItems(data);
    } catch (err) {
      console.error('Failed to fetch menu items:', err);
      setError('Não foi possível carregar os itens do cardápio.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!restaurantId) {
      setError('ID do restaurante não encontrado. Faça login novamente.');
      return;
    }

    try {
      const itemData = {
        Name: form.Name,
        Price: parseFloat(form.Price),
        Destination: form.Destination,
        RestaurantID: restaurantId,
      };

      if (form.ItemID) {
        await updateMenuItem(form.ItemID, itemData);
      } else {
        await createMenuItem(itemData);
      }
      setForm({ ItemID: null, Name: '', Price: '', Destination: 'kitchen' });
      fetchMenuItems();
    } catch (err) {
      console.error('Failed to save menu item:', err);
      setError('Falha ao salvar item do cardápio. Verifique os dados.');
    }
  };

  const handleEdit = (item) => {
    setForm({
      ItemID: item.ItemID,
      Name: item.Name,
      Price: item.Price,
      Destination: item.Destination,
    });
  };

  const handleDelete = async (itemId) => {
    setError('');
    if (window.confirm('Tem certeza que deseja excluir este item do cardápio?')) {
      try {
        await deleteMenuItem(itemId);
        fetchMenuItems();
      } catch (err) {
        console.error('Failed to delete menu item:', err);
        setError('Falha ao excluir item do cardápio.');
      }
    }
  };

  if (loading) {
    return <div style={styles.loading}>Carregando itens do cardápio...</div>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Gerenciar Cardápio</h2>
      <button onClick={() => navigate('/restaurant/dashboard')} style={styles.backButton}>
        Voltar ao Painel
      </button>

      <div style={styles.formSection}>
        <h3>{form.ItemID ? 'Editar Item' : 'Adicionar Novo Item'}</h3>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            name="Name"
            placeholder="Nome do Item"
            value={form.Name}
            onChange={handleChange}
            style={styles.input}
            required
          />
          <input
            type="number"
            name="Price"
            placeholder="Preço"
            value={form.Price}
            onChange={handleChange}
            style={styles.input}
            step="0.01"
            required
          />
          <select
            name="Destination"
            value={form.Destination}
            onChange={handleChange}
            style={styles.select}
            required
          >
            <option value="kitchen">Cozinha</option>
            <option value="bar">Bar</option>
          </select>
          <button type="submit" style={styles.submitButton}>
            {form.ItemID ? 'Salvar Alterações' : 'Adicionar Item'}
          </button>
          {form.ItemID && (
            <button type="button" onClick={() => setForm({ ItemID: null, Name: '', Price: '', Destination: 'kitchen' })} style={styles.cancelButton}>
              Cancelar Edição
            </button>
          )}
        </form>
      </div>

      <div style={styles.listSection}>
        <h3>Lista de Itens</h3>
        {menuItems.length === 0 ? (
          <p>Nenhum item no cardápio.</p>
        ) : (
          <ul style={styles.list}>
            {menuItems.map((item) => (
              <li key={item.ItemID} style={styles.listItem}>
                <span>{item.Name} - R$ {item.Price.toFixed(2)} ({item.Destination})</span>
                <div style={styles.actions}>
                  <button onClick={() => handleEdit(item)} style={styles.editButton}>Editar</button>
                  <button onClick={() => handleDelete(item.ItemID)} style={styles.deleteButton}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#f0f2f5',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    color: '#333',
    marginBottom: '20px',
  },
  backButton: {
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginBottom: '20px',
  },
  formSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    marginBottom: '20px',
    width: '100%',
    maxWidth: '600px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '10px',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
  },
  select: {
    padding: '10px',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
    backgroundColor: '#fff',
  },
  submitButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  cancelButton: {
    backgroundColor: '#ffc107',
    color: '#333',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  listSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    width: '100%',
    maxWidth: '600px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0',
    borderBottom: '1px solid #eee',
  },
  actions: {
    display: 'flex',
    gap: '10px',
  },
  editButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 12px',
    cursor: 'pointer',
  },
  deleteButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 12px',
    cursor: 'pointer',
  },
  loading: {
    fontSize: '18px',
    color: '#555',
    marginTop: '50px',
  },
  error: {
    color: 'red',
    marginBottom: '10px',
    textAlign: 'center',
  },
};

export default ManageMenuItemsScreen;
